import { useEffect } from 'react';

const useScrollToTopOnChange = (trigger: string | number): void => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [trigger]);
};

export default useScrollToTopOnChange;
